
import React from "react";
import banner from "../../assets/images/trustworthy-about-banner.jpg";

const PrivacyPolocy = () => {
  return (
    <>
      {/* Inner Banner */}
      <section className="inner-banner">
        <img
          src={banner}
          alt="Privacy Policy Banner"
          className="inner-banner-img"
        />

        <div className="inner-banner-content">
          <div className="container">
            <div className="inner-banner-content-in">
              <h1>Privacy Policy</h1>

              <p>
                Best Home Servicing Company for Household Repairs or Servicing
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Privacy Policy Content */}
      <section className="privacy-policy py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">

              <h1 className="mb-3 text-center fw-bold">
                Privacy Policy
              </h1>

              <p>
                <strong>Last Updated: 24 September 2026</strong>
              </p>

              <p>
                At <strong>Sevasati</strong>, we respect your privacy and are
                committed to protecting the personal information of our
                customers, vendors, service providers, and other users of our
                mobile application and website.
              </p>

              <p>
                This Privacy Policy explains how Sevasati collects, uses,
                stores, protects, and shares information when you use our
                website, mobile application, services, and related platforms.
              </p>

              <p>
                By accessing or using Sevasati, you acknowledge that you have
                read and understood this Privacy Policy and agree to the
                practices described below.
              </p>

              {/* 1 */}
              <h2>1. Information We Collect</h2>

              <p>
                Depending on how you use Sevasati, we may collect the following
                types of information:
              </p>

              <h4>Personal Information</h4>

              <ul>
                <li>Name</li>
                <li>Mobile number</li>
                <li>Email address</li>
                <li>Profile information</li>
                <li>Address</li>
                <li>Service location</li>
                <li>City, state, and PIN code</li>
                <li>Profile photograph, where provided</li>
                <li>Information required for service booking</li>
              </ul>

              <h4>Account and Login Information</h4>

              <p>
                Sevasati may use mobile number-based OTP authentication for
                registration and login. We may collect and process your mobile
                number and OTP verification information for authentication and
                account security.
              </p>

              <p>
                OTPs are used for verification and authentication purposes and
                are not intended to be used as your permanent password.
              </p>

              {/* 2 */}
              <h2>2. Customer Profile Information</h2>

              <p>
                Customers may create and manage their profiles through the
                Sevasati application. This may include:
              </p>

              <ul>
                <li>Editing personal profile information</li>
                <li>Updating contact details</li>
                <li>Updating address information</li>
                <li>Changing account password where applicable</li>
                <li>Managing service-related information</li>
              </ul>

              <p>
                We use this information to maintain your account and provide
                requested services.
              </p>

              {/* 3 */}
              <h2>3. Services and Service Categories</h2>

              <p>
                Sevasati provides information about different services,
                categories, sub-categories, featured services, latest services,
                and special offers.
              </p>

              <p>
                We may collect information related to the services you view,
                select, add to your cart, book, or otherwise interact with in
                order to provide and improve our services.
              </p>

              {/* 4 */}
              <h2>4. Service Booking Information</h2>

              <p>
                When you book a service through Sevasati, we may collect and
                process information necessary to complete the booking,
                including:
              </p>

              <ul>
                <li>Selected service</li>
                <li>Selected vendor or service provider</li>
                <li>Service address</li>
                <li>Selected date</li>
                <li>Selected time slot</li>
                <li>Booking details</li>
                <li>Service status</li>
                <li>Payment-related information</li>
              </ul>

              <p>
                This information is used to arrange, manage, track, and
                complete your requested service.
              </p>

              {/* 5 */}
              <h2>5. Location Information</h2>

              <p>
                Sevasati may request access to your location when required to
                provide location-based services.
              </p>

              <p>
                Location information may be used to:
              </p>

              <ul>
                <li>Identify your service location</li>
                <li>Display vendors available in your area</li>
                <li>Calculate or display approximate vendor distance</li>
                <li>Help vendors reach the customer's service location</li>
                <li>Improve location-based service availability</li>
              </ul>

              <p>
                You may control location permissions through your device
                settings. Disabling location access may affect certain
                location-based features of the application.
              </p>

              {/* 6 */}
              <h2>6. Vendor Information</h2>

              <p>
                Sevasati may display information about vendors or service
                providers to customers. Such information may include:
              </p>

              <ul>
                <li>Vendor name</li>
                <li>Profile information</li>
                <li>Services offered</li>
                <li>Service categories</li>
                <li>Ratings and reviews</li>
                <li>Service availability</li>
                <li>Approximate distance from the customer</li>
              </ul>

              <p>
                Vendor information is used to help customers select and book
                suitable service providers.
              </p>

              {/* 7 */}
              <h2>7. Vendor Mobile Application</h2>

              <p>
                Vendors using the Sevasati Vendor Application may provide
                additional information required to manage their accounts and
                services.
              </p>

              <p>This may include:</p>

              <ul>
                <li>Mobile number and OTP verification</li>
                <li>Vendor profile information</li>
                <li>Service-related information</li>
                <li>Booking/request information</li>
                <li>Service status information</li>
                <li>Commission-related information</li>
                <li>Payment and report information</li>
              </ul>

              <p>
                Vendor information is used to manage service requests,
                accept or reject bookings, update service status, manage
                commissions, and generate payment reports.
              </p>

              {/* 8 */}
              <h2>8. Payments and Payment Gateway</h2>

              <p>
                Sevasati may provide online payment functionality through a
                third-party payment gateway.
              </p>

              <p>
                Payment transactions may be processed by the selected payment
                gateway provider. Sevasati may receive limited transaction
                information such as payment status, transaction reference,
                amount, and related booking information.
              </p>

              <p>
                Sevasati does not intend to store your complete debit card,
                credit card, banking password, UPI PIN, or other sensitive
                payment authentication information on its own servers unless
                specifically required and lawfully permitted.
              </p>

              <p>
                Payment processing may also be subject to the privacy policy
                and terms of the relevant payment service provider.
              </p>

              {/* 9 */}
              <h2>9. Cart and Order Information</h2>

              <p>
                When you add services to your cart, we may process information
                about the selected services, quantities, prices, special
                prices, coupons, and other related information.
              </p>

              <p>
                This information helps us process your service booking and
                provide an accurate order summary.
              </p>

              {/* 10 */}
              <h2>10. Coupons and Special Offers</h2>

              <p>
                Sevasati may provide promotional offers, discount services,
                coupon codes, and special offers.
              </p>

              <p>
                We may process information about coupon usage and promotional
                activity to validate offers, prevent misuse, and improve our
                promotional services.
              </p>

              {/* 11 */}
              <h2>11. Refer and Earn</h2>

              <p>
                Sevasati may provide a referral and reward feature. If you
                participate in our Refer and Earn program, we may process
                referral-related information such as referral codes, referral
                activity, and applicable rewards.
              </p>

              <p>
                Referral information is used to administer the referral
                program and determine applicable benefits or rewards.
              </p>

              {/* 12 */}
              <h2>12. Ratings and Feedback</h2>

              <p>
                Customers may provide ratings, reviews, and feedback regarding
                services or vendors.
              </p>

              <p>
                Such feedback may be displayed within the Sevasati application
                or website to help other customers understand service
                experiences.
              </p>

              <p>
                We may use feedback to monitor service quality and improve the
                Sevasati platform.
              </p>

              {/* 13 */}
              <h2>13. Push Notifications</h2>

              <p>
                Sevasati may send push notifications to customers and vendors
                for important service-related updates.
              </p>

              <p>Notifications may include:</p>

              <ul>
                <li>Booking confirmations</li>
                <li>Booking status changes</li>
                <li>Vendor request updates</li>
                <li>Service accepted or rejected notifications</li>
                <li>Service completion updates</li>
                <li>Promotional offers</li>
                <li>Other important account notifications</li>
              </ul>

              <p>
                You can manage notification permissions through your device
                settings.
              </p>

              {/* 14 */}
              <h2>14. Service Status Information</h2>

              <p>
                Sevasati may maintain service status information such as:
              </p>

              <ul>
                <li>Pending services</li>
                <li>Ongoing services</li>
                <li>Completed services</li>
                <li>Cancelled services</li>
              </ul>

              <p>
                This information is used to provide customers and vendors with
                accurate service tracking and management.
              </p>

              {/* 15 */}
              <h2>15. Vendor Service Requests</h2>

              <p>
                Vendors may receive service requests through the Vendor
                Application. Vendors may accept or reject service requests and
                update the status of services.
              </p>

              <p>
                Relevant booking and customer information may be shared with
                the assigned vendor when necessary to provide the requested
                service.
              </p>

              {/* 16 */}
              <h2>16. Splash Screen and Application Content</h2>

              <p>
                Sevasati may display application branding, promotional content,
                banners, sliders, featured services, latest services, and other
                content through the mobile application and website.
              </p>

              {/* 17 */}
              <h2>17. CMS and Website Information</h2>

              <p>
                Sevasati may provide informational pages such as About Us,
                Contact Us, Privacy Policy, Terms and Conditions, and other
                content managed through our website or application.
              </p>

              {/* 18 */}
              <h2>18. Contact Us Information</h2>

              <p>
                If you contact us through a contact form, email, phone number,
                or other communication channel, we may collect the information
                you provide, including your name, contact details, and message.
              </p>

              <p>
                This information is used to respond to your inquiry, provide
                customer support, and resolve service-related issues.
              </p>

              {/* 19 */}
              <h2>19. Log Files and Technical Information</h2>

              <p>
                Like many online services, Sevasati may collect technical
                information automatically when you use our website or
                application.
              </p>

              <p>This may include:</p>

              <ul>
                <li>IP address</li>
                <li>Browser type</li>
                <li>Device type</li>
                <li>Operating system</li>
                <li>Application version</li>
                <li>Date and time of access</li>
                <li>Pages or features accessed</li>
                <li>Error and diagnostic information</li>
              </ul>

              <p>
                This information may be used for security, troubleshooting,
                analytics, application improvement, and service administration.
              </p>

              {/* 20 */}
              <h2>20. Cookies and Tracking Technologies</h2>

              <p>
                Our website may use cookies and similar technologies to
                maintain sessions, remember preferences, understand usage
                patterns, improve website performance, and provide a better
                user experience.
              </p>

              <p>
                You can manage or disable cookies through your browser settings.
                Some features may not function properly if cookies are
                disabled.
              </p>

              {/* 21 */}
              <h2>21. Third-Party Services</h2>

              <p>
                Sevasati may use third-party service providers for purposes
                such as:
              </p>

              <ul>
                <li>Payment processing</li>
                <li>OTP and SMS delivery</li>
                <li>Push notifications</li>
                <li>Analytics</li>
                <li>Cloud hosting</li>
                <li>Application infrastructure</li>
                <li>Customer communication</li>
                <li>Other service-related functions</li>
              </ul>

              <p>
                These third parties may process information according to their
                own privacy policies and applicable legal requirements.
              </p>

              {/* 22 */}
              <h2>22. How We Use Your Information</h2>

              <p>
                We may use collected information for the following purposes:
              </p>

              <ul>
                <li>Creating and managing user accounts</li>
                <li>Verifying users through OTP</li>
                <li>Providing requested services</li>
                <li>Processing service bookings</li>
                <li>Connecting customers with vendors</li>
                <li>Displaying vendor information</li>
                <li>Displaying vendor distance where applicable</li>
                <li>Processing payments</li>
                <li>Managing coupons and special offers</li>
                <li>Managing referral programs</li>
                <li>Sending notifications</li>
                <li>Providing customer support</li>
                <li>Managing ratings and feedback</li>
                <li>Improving application functionality</li>
                <li>Preventing fraud and misuse</li>
                <li>Maintaining platform security</li>
                <li>Complying with applicable legal requirements</li>
              </ul>

              {/* 23 */}
              <h2>23. Information Sharing</h2>

              <p>
                We do not sell your personal information as a standalone
                product.
              </p>

              <p>
                We may share necessary information with vendors, service
                providers, payment providers, technology providers, or other
                parties when such sharing is required to provide the services
                requested by you or operate the Sevasati platform.
              </p>

              <p>
                Information may also be disclosed where required by applicable
                law, regulation, legal process, or to protect the rights,
                safety, and security of Sevasati, our users, vendors, or other
                parties.
              </p>

              {/* 24 */}
              <h2>24. Data Security</h2>

              <p>
                Sevasati takes reasonable technical and organizational measures
                to protect personal information against unauthorized access,
                misuse, alteration, disclosure, or destruction.
              </p>

              <p>
                However, no method of electronic transmission or storage can be
                guaranteed to be completely secure. Therefore, we cannot
                guarantee absolute security of your information.
              </p>

              {/* 25 */}
              <h2>25. Data Retention</h2>

              <p>
                We may retain personal information for as long as reasonably
                necessary to provide our services, maintain accounts, complete
                transactions, resolve disputes, maintain business records,
                prevent fraud, and comply with legal or regulatory obligations.
              </p>

              {/* 26 */}
              <h2>26. Children's Privacy</h2>

              <p>
                Sevasati services are not intended to knowingly collect
                personal information from children under the age of 13.
              </p>

              <p>
                If we become aware that personal information has been
                unintentionally collected from a child under the applicable age,
                we will take reasonable steps to address the situation.
              </p>

              {/* 27 */}
              <h2>27. Your Choices and Rights</h2>

              <p>
                Subject to applicable law and platform requirements, you may
                have rights regarding your personal information, including the
                ability to:
              </p>

              <ul>
                <li>Update or correct account information</li>
                <li>Manage certain device permissions</li>
                <li>Manage notification preferences</li>
                <li>Request information regarding your personal data</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion where legally applicable</li>
              </ul>

              <p>
                To make a privacy-related request, please contact Sevasati
                using the contact information provided on our website or
                application.
              </p>

              {/* 28 */}
              <h2>28. Changes to This Privacy Policy</h2>

              <p>
                Sevasati may update this Privacy Policy from time to time to
                reflect changes in our services, technology, legal requirements,
                or business practices.
              </p>

              <p>
                When we make changes, we may update the "Last Updated" date
                shown at the beginning of this Privacy Policy.
              </p>

              <p>
                We encourage users to review this Privacy Policy periodically.
              </p>

              {/* 29 */}
              <h2>29. Contact Us</h2>

              <p>
                If you have questions, concerns, or requests regarding this
                Privacy Policy or the handling of your personal information,
                please contact Sevasati through the contact details provided on
                our official website or mobile application.
              </p>

              <p>
                <strong>Sevasati</strong>
              </p>

              <p>
                For privacy-related queries, please use the Contact Us section
                available on the Sevasati website or application.
              </p>

              {/* Consent */}
              <h2>30. Consent</h2>

              <p>
                By using the Sevasati website, Customer Application, Vendor
                Application, or related services, you acknowledge that you have
                read and understood this Privacy Policy and consent to the
                collection, use, storage, and sharing of information as
                described in this Privacy Policy, subject to applicable law.
              </p>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolocy;

